import { convertNumberToWords } from './convertNumberToWords'

export const formatPercent = (cellValue: string, easterEggMode?: boolean) => {
  const percentageDigit = Math.round(Number(cellValue) * 10) / 10

  if (easterEggMode) return convertNumberToWords(percentageDigit) + ' procent'

  return `${percentageDigit?.toString()} %`
}
